import * as tokens from '../../../../../tokens/color.light.generated.js';
export const systemColorLight = {
    color: {
        foreground: {
            interactive: {
                primary: {
                    100: tokens.SYS_COLOR_FOREGROUND_INTERACTIVE_PRIMARY_100_LIGHT,
                    200: tokens.SYS_COLOR_FOREGROUND_INTERACTIVE_PRIMARY_200_LIGHT,
                    300: tokens.SYS_COLOR_FOREGROUND_INTERACTIVE_PRIMARY_300_LIGHT
                }
            },
            neutral: {
                100: tokens.SYS_COLOR_FOREGROUND_NEUTRAL_100_LIGHT,
                200: tokens.SYS_COLOR_FOREGROUND_NEUTRAL_200_LIGHT,
                300: tokens.SYS_COLOR_FOREGROUND_NEUTRAL_300_LIGHT,
                800: tokens.SYS_COLOR_FOREGROUND_NEUTRAL_800_LIGHT
            },
            signal: {
                positive: {
                    100: tokens.SYS_COLOR_FOREGROUND_SIGNAL_POSITVE_100_LIGHT,
                    200: tokens.SYS_COLOR_FOREGROUND_SIGNAL_POSITVE_200_LIGHT
                },
                pending: tokens.SYS_COLOR_FOREGROUND_SIGNAL_PENDING_LIGHT,
                negative: tokens.SYS_COLOR_FOREGROUND_SIGNAL_NEGATIVE_LIGHT
            }
        },
        surface: {
            interactive: {
                primary: {
                    100: tokens.SYS_COLOR_SURFACE_INTERACTIVE_PRIMARY_100_LIGHT,
                    200: tokens.SYS_COLOR_SURFACE_INTERACTIVE_PRIMARY_200_LIGHT
                }
            },
            highlight: {
                primary: tokens.SYS_COLOR_SURFACE_HIGHLIGHT_PRIMARY_LIGHT
            },
            signal: {
                success: {
                    100: tokens.SYS_COLOR_SURFACE_SIGNAL_SUCCESS_100_LIGHT,
                    200: tokens.SYS_COLOR_SURFACE_SIGNAL_SUCCESS_200_LIGHT
                },
                pending: tokens.SYS_COLOR_SURFACE_SIGNAL_PENDING_LIGHT,
                negative: tokens.SYS_COLOR_SURFACE_SIGNAL_NEGATIVE_LIGHT,
                focus: tokens.SYS_COLOR_SURFACE_SIGNAL_FOCUS_LIGHT,
                indicator: {
                    default: tokens.SYS_COLOR_SURFACE_SIGNAL_INDICATOR_DEFAULT_LIGHT,
                    green: tokens.SYS_COLOR_SURFACE_SIGNAL_INDICATOR_GREEN_LIGHT,
                    blue: tokens.SYS_COLOR_SURFACE_SIGNAL_INDICATOR_BLUE_LIGHT,
                    red: tokens.SYS_COLOR_SURFACE_SIGNAL_INDICATOR_RED_LIGHT,
                    yellow: tokens.SYS_COLOR_SURFACE_SIGNAL_INDICATOR_YELLOW_LIGHT,
                    turquoise: tokens.SYS_COLOR_SURFACE_SIGNAL_INDICATOR_TURQUOISE_LIGHT
                }
            }
        }
    }
};
//# sourceMappingURL=color.light.js.map